/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FileInputs */



/**
* | output |
* | --- |
* | "File" |
*
* @param {FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file = /** @type {((inputs?: FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei")
	if (locale === "it") return /** @type {LocalizedString} */ ("File")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo")
	return /** @type {LocalizedString} */ ("File")
});